import { ICellRendererParams } from 'ag-grid-community'
import { SubStatusRow } from '../SubStatusRow'
import { ERROR_CELL_BACKGROUND } from '../lib/gridUtils'

// context.duplicateNames は index.tsx が rowData から算出して updateContext で流し込む。
const getDuplicateNames = (context: unknown): Set<string> => {
  const duplicateNames = (context as { duplicateNames?: Set<string> })
    ?.duplicateNames
  return duplicateNames ?? new Set<string>()
}

// 名称列のセルレンダラー(TicketTypes 画面の NameCellRenderer に倣う)。
// 検証エラー(重複名 / 紐づくステータスは入っているのに名前が空)を赤背景で示す。
export const NameCellRenderer = (params: ICellRendererParams<SubStatusRow>) => {
  const { value, data, context } = params
  const name = (value ?? '').trim()
  const hasStatus = !!data?.linkedStatus
  const isMissing = hasStatus && !name
  const isDuplicate =
    !!name && getDuplicateNames(context).has(name.toLowerCase())
  const hasError = isMissing || isDuplicate
  return (
    <div
      className="sevend-ag-cell"
      style={{ backgroundColor: hasError ? ERROR_CELL_BACKGROUND : undefined }}
    >
      {value}
    </div>
  )
}
